import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@stance/"

const loadStanceCustomLabels = makePieActionObjs("load", "stanceCustomLabels")
export const loadStanceCustomLabelsActionDict = prependAppName(appName, loadStanceCustomLabels.pieDict)

const updateStanceCustomLabel = makePieActionObjs("patch", "stanceCustomLabel")
export const updateStanceCustomLabelActionDict = prependAppName(appName, updateStanceCustomLabel.pieDict)

const createStanceCustomLabel = makePieActionObjs("patch", "stanceCustomLabel")
export const createStanceCustomLabelActionDict = prependAppName(appName, createStanceCustomLabel.pieDict)

const updateStanceAlertName = makePieActionObjs("patch", "stanceAlertTitle")
export const updateStanceAlertNameActionDict = prependAppName(appName, updateStanceAlertName.pieDict)

export default prependAppName(
    appName,
    {
        ...loadStanceCustomLabels.actionTypes,
        ...updateStanceCustomLabel.actionTypes,
        ...createStanceCustomLabel.actionTypes,
        ...updateStanceAlertName.actionTypes,
    }
)
